import { WarningTriangle } from '@byway/icons';
import styles from './FormError.module.css';

export const FormError = ({ message }: { message?: string }) => {
  return (
    <p className={styles.error} role="alert">
      <WarningTriangle decorative className={styles.icon} size="large" />
      {message}
    </p>
  );
};
